import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MydocState } from './mydoc.state';

export const MY_DOC_FEATURE_KEY = 'MY_DOC_FEATURE_KEY';
const initialMydocState = createFeatureSelector<MydocState>(MY_DOC_FEATURE_KEY);

export const storedSession = createSelector(
  initialMydocState,
  (state) => state.session
);
export const documentSession = createSelector(
  initialMydocState,
  (state) => state.session.documentSession
);
export const sessionLanguage = createSelector(
  initialMydocState,
  (state) => state.session.language
);
export const storedExportSettings = createSelector(
  initialMydocState,
  (state) => state.exportSettings
);
export const currentStep = createSelector(
  initialMydocState,
  (state) => state.currentStep
);
export const selectedDocumentTypes = createSelector(
  initialMydocState,
  (state) => state.selectedDocumentTypes
);
export const selectedCadTypes = createSelector(
  initialMydocState,
  (state) => state.selectedCadTypes
);
export const availableDocumentTypes = createSelector(
  initialMydocState,
  (state) => state.availableDocumentTypes
);
export const availableCadTypes = createSelector(
  initialMydocState,
  (state) => state.availableCadTypes
);
export const selectedProducts = createSelector(
  initialMydocState,
  (state) => state.selectedProducts
);

export const defaultConfiguration = createSelector(
  initialMydocState,
  (state) => state.exportSettings.defaultConfiguration
);
export const availableConfiguration = createSelector(
  initialMydocState,
  (state) => state.exportSettings.availableConfiguration
);
export const savedConfiguration = createSelector(
  initialMydocState,
  (state) => state.exportSettings.savedConfiguration
);
export const availableLanguages = createSelector(
  initialMydocState,
  (state) => state.language.available
);
export const selectedLanguages = createSelector(
  initialMydocState,
  (state) => state.language.selected
);
export const needToSaveSettings = createSelector(
  initialMydocState,
  (state) => state.needToSaveSettings
);
export const showErrorMessage = createSelector(
  initialMydocState,
  (state) => state.showErrorMessage
);
